<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasExport" type="primary" @click="onDownExcel">导出</el-button>
        <el-button v-if="hasAdd" type="primary" @click="$router.push('/qualityControlReport/add')">新增</el-button>
      </template>
      <el-form inline ref="searchFormRef" class="global-form-label-width" :model="searchForm">
        <el-form-item label="品种规格" prop='specName'>
          <el-input clearable v-model="searchForm.specName" placeholder="品种规格" />
        </el-form-item>
        <el-form-item prop="productionDate" label="生产日期">
          <el-date-picker v-model="searchForm.productionDate" placeholder="请选择生产日期" type="date" clearable
                          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="storageType" label="出入库类型">
          <el-select v-model="searchForm.storageType" clearable filterable placeholder="请选择出入库类型">
            <el-option v-for="(item, index) of typeArr" :value="item.value" :label="item.label"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="storageDate" label="出入库日期">
          <el-date-picker v-model="searchForm.storageDate" placeholder="请选择出入库日期" type="date" clearable
                          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="testResult" label="质检结果">
          <el-select v-model="searchForm.testResult" clearable filterable placeholder="请选择质检结果">
            <el-option v-for="(item, index) of resArr" :value="item.value" :label="item.label" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="goodsId" label="原料供应商">
          <el-select v-model="searchForm.goodsId" clearable filterable placeholder="请选择原料供应商">
            <el-option v-for="(item, index) of supplierArr" :value="item.materialsId" :label="item.materialsName"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="createTime" label="创建时间">
          <el-date-picker v-model="dateArr" @change="changeDate" type="datetimerange" range-separator="至"
                          start-placeholder="开始时间" end-placeholder="结束时间" clearable format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="生产日期" prop="productionDate"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="出入库类型" prop="storageType">
          <template v-slot="{ row }">
            {{ row.storageType == '1' ? '入库' : row.storageType == '2' ? '出库' : row.storageType == '3' ? '外采外销' : '' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="出入库日期" prop="storageDate"> </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="品种规格" prop="specName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="原料供应商" prop="goodsName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="车牌号/罐号" prop="plateNumber"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="质检结果" prop="testResult">
          <template v-slot="{ row }">
            <el-tag type="success" v-if="row.testResult == '1'">合格</el-tag>
            <el-tag type="danger" v-if="row.testResult == '2'">不合格</el-tag>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建人" prop="createUserName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="180" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/qualityControlReport/detail?reportId=' + row.reportId)">详情</el-button>

            <el-button type="text" v-if="hasEdit"
                       @click="$router.push('/qualityControlReport/edit?reportId=' + row.reportId)">编辑</el-button>

            <el-button type="text" v-if="hasDel" @click="deleteRow(row.reportId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>

    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>
  </div>
</template>

<script>
import SpecChoose from '@/components/SpecChoose.vue'

export default {
  name: 'qualityControlReport',
  components: {
    SpecChoose
  },
  data() {
    return {
      dialogVisible: false,
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      dateArr: [],
      searchForm: {
        productionDate: null,
        storageType: null,
        storageDate: null,
        specName: null,
        testResult: null,
        goodsId: null,
        startTime: '',
        endTime: ''
      },
      //  1入库2出库 3外采外销
      typeArr: [
        { label: '入库', value: '1' },
        { label: '出库', value: '2' },
        { label: '外采外销', value: '3' }
      ],
      resArr: [
        { label: '合格', value: '1' },
        { label: '不合格', value: '2' }
      ],
      specArr: [],
      supplierArr: []
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },
  created() {
    this.loadSpec()
    this.loadSupplier()
    this.loadData()
  },
  methods: {
    onSpecSelect(data) {
      console.log('data', data)
      this.searchForm.specName = data.specName
      this.dialogVisible = false
    },
    changeDate(date) {
      if (date && date.length) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    loadSupplier() {
      this.$axios.get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByList).then(res => {
        this.supplierArr = res.list || []
      })
    },
    loadSpec() {
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.specArr = res.list || []
        })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.qualityControlReport.selectPaQcReportByPage, {
        params: {
          page: this.page,
          size: 10,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      // 重置表单校验
      this.$refs.searchFormRef && this.$refs.searchFormRef.resetFields()
      // 对象完整重置
      this.searchForm = {
        productionDate: null,
        storageType: null,
        storageDate: null,
        specName: null,
        testResult: null,
        goodsId: null,
        startTime: '',
        endTime: ''
      }
      // 清空时间范围组件UI
      this.dateArr = []
      this.onSearch()
    },
    deleteRow(reportId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.qualityControlReport.deleteDataPaQcReport, {
          reportId
        }).then(() => {
          this.loadData()
        }).catch(err => {
          console.error('删除失败', err)
        })
      }).catch(() => {
        // 用户点取消，捕获reject，消除控制台警告
      })
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.qualityControlReport.exportPaQcReport, {
        ...this.searchForm
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    }
  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
